import { useMemo } from "react";

import { IVideoEmbedData, FormattedImage } from "~/types/api-types";

import { UseMediaProcessingProps, UseMediaProcessingReturn } from "../types";

export const useMediaProcessing = ({
  images,
  videos,
  defaultAlt,
}: UseMediaProcessingProps): UseMediaProcessingReturn => {
  const formattedImages = useMemo(() => {
    if (images.length > 0) {
      return images.map((image) => ({
        id: image?.externalId || "",
        alt: image?.description || defaultAlt,
        sort_order: image?.sort_order || 0,
      }));
    }

    // fallback to listing placeholder if no images are found
    return [
      {
        id: "v1506548002/listing-placeholder_zmaod9",
        alt: "Listing Placeholder",
        sort_order: 0,
      },
    ];
  }, [images, defaultAlt]);

  // Combine images and videos into a unified media array, sorted by their sort_order property
  // Both data types (images and embed_data/videos) include sort_order for proper gallery sequencing
  // combined media is shown in the image gallery and photo viewer
  const combinedMedia = useMemo(() => {
    return [...videos, ...formattedImages].sort(
      (a, b) => (a.sort_order || 0) - (b.sort_order || 0),
    ) as (IVideoEmbedData & FormattedImage)[];
  }, [videos, formattedImages]);

  return {
    formattedImages,
    combinedMedia,
  };
};
